import { Card, CardContent, CardMedia } from "@mui/material";
import React from "react";
import { ceoImage } from "../../../assets";

export default function CardCeo() {
  return (
    <>
      <Card
        className="card-ceo-p d-flex"
        style={{
          backgroundColor: "#2F8956",
          borderRadius: "15px",
          boxShadow: "20px 20px rgba(0, 0, 0)",
        }}
      >
        <CardContent
          className="card-ceo d-flex justify-content-between align-items-center"
          sx={{ padding: 0 }}
        >
          <CardMedia
            component="img"
            className="card-ceo-img"
            loading="lazy"
            image={ceoImage}
            // image="https://ik.imagekit.io/mostrans/ceo.png?updatedAt=1699856982906"
            // image="https://ik.imagekit.io/mostrans/IMG_4938.jpg?updatedAt=1696494082754"
            alt="CEO Mostrans - Berty Argiyantari"
          />
          <div className="card-ceo-content p-3">
            <h4 className="text-warning-hm" style={{ fontWeight: 500 }}>
              Kenal Dekat Dengan CEO Kami
            </h4>
            <p className="text-white text-justify mt-1" style={{ fontSize: "14px" }}>
              Mostrans hadir dengan ekosistem  digital revolusioner dalam
              industri layanan kesehatan dan transportasi. Kami bertekad kuat
              untuk membawa perubahan positif, menjadikan Indonesia lebih sehat.
              Kesehatan adalah hak asasi setiap individu, dan sistem handal
              adalah kunci distribusi logistik kesehatan yang efisien. Melalui
              platform inovatif kami, Mostrans menghubungkan titik-titik penting
              dalam ekosistem kesehatan, memastikan distribusi yang mudah dan
              cepat untuk semua orang. Mostrans bukan hanya bisnis, tetapi juga
              tentang dampak positif pada masyarakat.
            </p>
            {/* <Paper
              // className="ceo-name"
              elevation={0}
              sx={{
                width: "max-content",
                marginTop: "1.5rem",
                padding: "8px",
                borderRadius: "10px",
              }}
            > */}
            <h6 className="text-warning-hm mt-1">
              CEO Mostrans - Berty Argiyantari
            </h6>
            {/* </Paper> */}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
